var metric, imperial;

metric = {
  Nm: {
    name: {
      singular: "Newton-meter",
      plural: "Newton-meters",
    },
    to_anchor: 1,
  },
  mNm: {
    name: {
      singular: "Milli Newton-meter",
      plural: "Milli Newton-meters",
    },
    to_anchor: 0.001, // 1 mNm = 0.001 Nm
  },
  dNm: {
    name: {
      singular: "Deci Newton-meter",
      plural: "Deci Newton-meters",
    },
    to_anchor: 0.1, // 1 dNm = 0.1 Nm
  },
   cNm: {
    name: {
      singular: "centi Newton-meter",
      plural: "centi Newton-meters",
    },
    to_anchor: 0.01, // 1 cNm = 0.01 Nm
  },
  'kgf.m': {
    name: {
      singular: "Kilogram-force Meter",
      plural: "Kilogram-force Meters",
    },
    to_anchor: 9.80665,
  },
   'kgf.cm': {
    name: {
      singular: "Kilogram-force Centimeter",
      plural: "Kilogram-force Centimeters",
    },
    to_anchor: 0.0980665, // 1 kgf·cm = 0.0980665 Nm
  },
  //  'Lbf.ft': {
  //   name: {
  //     singular: "Pound Force-Foot",
  //     plural: "Pound Force-Feet",
  //   },
  //   to_anchor: 1.3558179483314,
  // },
  // 'Lbf.in': {
  //   name: {
  //     singular: "Pound Force-Inch",
  //     plural: "Pound Force-Inches",
  //   },
  //   to_anchor: 0.1129848290276,
  // },
  'ozf.in': {
    name: {
      singular: "Ounce-force Inch",
      plural: "Ounce-force Inches",
    },
    to_anchor: 0.00706155183333,
  },
  'ozf.ft': {
    name: {
      singular: "Ounce-force Foot",
      plural: "Ounce-force Feet",
    },
    to_anchor: 0.08473862199996,
  },
};

imperial = {
  "Lbf.in": {
    name: {
      singular: "Pound Force-Inch",
      plural: "Pound Force-Inches",
    },
    to_anchor: 1 / 12,
  },
  //  "ozf.in": {
  //   name: {
  //     singular: "Ounce-force Inch",
  //     plural: "Ounce-force Inches",
  //   },
  //   to_anchor: 1 / 192, // 1 ozf.in = (1/16)/12 Lbf.ft = 1/192 Lbf.ft
  // },
  "Lbf.ft": {
    name: {
      singular: "Pound Force-Foot",
      plural: "Pound Force-Feet",
    },
    to_anchor: 1, // Pound Force-Foot as a base unit
  },
  // "ozf.ft": {
  //   name: {
  //     singular: "Ounce-force Foot",
  //     plural: "Ounce-force Feet",
  //   },
  //   to_anchor: 1 / 16, // 1 Lbf.ft = 16 ozf.ft → so 1 ozf.ft = 1/16 Lbf.ft
  // },
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: "Nm",
      ratio: 1 / 0.737562,
    },
    imperial: {
      unit: "ftlb",
      ratio: 0.737562,
    },
  },
};
